// extracted by mini-css-extract-plugin
export var bd = "br10-kb";
export var bigger = "br10-nb";
export var detail = "br10-mb";
export var downloadBar = "br10-jb";
export var footBottom = "br10-ib";
export var footBottomDesc = "br10-pb";
export var footerBottom = "br10-rb";
export var ft = "br10-qb";
export var logo = "br10-lb";
export var red = "br10-ob";